import { render, staticRenderFns } from "./ShoppingCartButton.vue?vue&type=template&id=bb5c853e&"
import script from "./ShoppingCartButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports